import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type MemberAdminDataFragment = (
  { __typename: 'Member' }
  & Pick<Types.Member, 'id' | 'idEnterprisesAdmin' | 'idEnterprisesImplicitAdmin' | 'idPremOrgsAdmin' | 'memberType'>
);

export const MemberAdminDataFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MemberAdminData' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Member' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idEnterprisesAdmin' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idEnterprisesImplicitAdmin' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'idPremOrgsAdmin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'memberType' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseMemberAdminDataFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      MemberAdminDataFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseMemberAdminDataFragmentResult
  extends Omit<Apollo.UseFragmentResult<MemberAdminDataFragment>, 'data'> {
  data?: MemberAdminDataFragment;
}

export const useMemberAdminDataFragment = ({
  from,
  returnPartialData,
  ...options
}: UseMemberAdminDataFragmentOptions): UseMemberAdminDataFragmentResult => {
  const result = Apollo.useFragment<MemberAdminDataFragment>({
    ...options,
    fragment: MemberAdminDataFragmentDoc,
    fragmentName: 'MemberAdminData',
    from: {
      __typename: 'Member',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      if (
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === 'false' ||
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === null
      ) {
        console.warn('Fragment data is incomplete.', result);
      }
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as MemberAdminDataFragment };
};
